<template>
<div>

    <div class="w3-row" v-if=" $t('notice.cs.facebook') !== '' && $t('notice.cs.kakao') !== '' && $t('notice.cs.telegram') !== '' && $t('notice.cs.call') !== '' ">
        <div class="w3-col s3">
            <a v-bind:href="$t('notice.cs.facebook')" target="_blank">
                <img class="cs-image" src="../static/img/common/facbook_icon.png">
            </a>
        </div>
        <div class="w3-col s3">
            <a v-bind:href="$t('notice.cs.kakao')" target="_blank">
                <img class="cs-image" src="../static/img/common/kakao_icon.png">
            </a>
        </div>
        <div class="w3-col s3">
            <a v-bind:href="$t('notice.cs.telegram')" target="_blank">
                <img class="cs-image" src="../static/img/common/telegram_icon.png">
            </a>
        </div>
        <div class="w3-col s3">
            <a v-bind:href="$t('notice.cs.call')" target="_blank">
                <img class="cs-image" src="../static/img/common/call_icon.png">
            </a>
        </div>
    </div>

    <div class="w3-row" v-else-if=" $t('notice.cs.facebook') !== '' && $t('notice.cs.kakao') !== '' && $t('notice.cs.call') !== '' ">
        <div class="w3-col s4">
            <a v-bind:href="$t('notice.cs.facebook')" target="_blank">
                <img class="cs-image" src="../static/img/common/facbook_icon.png">
            </a>
        </div>
        <div class="w3-col s4">
            <a v-bind:href="$t('notice.cs.kakao')" target="_blank">
                <img class="cs-image" src="../static/img/common/kakao_icon.png">
            </a>
        </div>
        <div class="w3-col s4">
            <a v-bind:href="$t('notice.cs.call')" target="_blank">
                <img class="cs-image" src="../static/img/common/call_icon.png">
            </a>
        </div>
    </div>

    <div class="w3-row" v-else-if=" $t('notice.cs.facebook') !== '' && $t('notice.cs.call') !== '' ">
        <div class="w3-col s6">
            <a v-bind:href="$t('notice.cs.facebook')" target="_blank">
                <img class="cs-image" src="../static/img/common/facbook_icon.png">
            </a>
        </div>
        <div class="w3-col s6">
            <a v-bind:href="$t('notice.cs.call')" target="_blank">
                <img class="cs-image" src="../static/img/common/call_icon.png">
            </a>
        </div>
    </div>

</div>
</template>

<style scoped>
.cs-image {
    height: 50px;
    width: 50px;
}
</style>

<script>
export default {
  name: 'CustomerCenter'
}
</script>
